// extracted by mini-css-extract-plugin
module.exports = {"box":"ProductCard_box__W5tMi","image":"ProductCard_image__jS9kg","title":"ProductCard_title__AH6iR"};